var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cross",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.606601 0.292893C0.216077 0.683417 0.216077 1.31658 0.606601 1.70711L4.6924 5.79291L0.292893 10.1924C-0.0976311 10.5829 -0.0976311 11.2161 0.292893 11.6066C0.683417 11.9972 1.31658 11.9972 1.70711 11.6066L6.10662 7.20712L10.5061 11.6066C10.8966 11.9971 11.5298 11.9971 11.9203 11.6066C12.3108 11.2161 12.3108 10.5829 11.9203 10.1924L7.52083 5.79291L11.6066 1.70714C11.9971 1.31661 11.9971 0.683447 11.6066 0.292922C11.2161 -0.097602 10.5829 -0.097602 10.1924 0.292922L6.10662 4.37869L2.02081 0.292893C1.63029 -0.0976311 0.997126 -0.0976311 0.606601 0.292893Z",
    fill: "#747487"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.12272cde.svg";
export { ForwardRef as ReactComponent };